import { Capacitor } from '@capacitor/core'
import { Text } from '@cretesuite/design-system'
import {
  IonContent,
  IonPage,
  IonSpinner,
  isPlatform,
  useIonRouter,
} from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { useEffect, useRef } from 'react'
import { Logo } from '../components/Logo'
import { ANDROID_STORE_URL, IOS_STORE_URL } from '../data/app'

/** `/download` — store redirect (v1 parity); native or desktop go home. */
export const DownloadAppPage = () => {
  const { _ } = useLingui()
  const router = useIonRouter()
  const hasExecuted = useRef(false)

  useEffect(() => {
    if (hasExecuted.current) return
    hasExecuted.current = true

    if (!Capacitor.isNativePlatform()) {
      const storeUrl = isPlatform('ios')
        ? IOS_STORE_URL
        : isPlatform('android')
          ? ANDROID_STORE_URL
          : ''
      if (storeUrl) window.open(storeUrl, '_self')
    }
    router.push('/', 'none', 'replace')
  }, [router])

  return (
    <IonPage>
      <IonContent fullscreen className='ion-padding ion-text-center'>
        <div className='auth-layout'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 8,
              marginBottom: 24,
            }}
          >
            <Text variant='body' style={{ fontWeight: 500 }}>
              {_(msg`Redirecting`)}
            </Text>
            <IonSpinner name='dots' />
          </div>
          <div className='auth-layout__logo'>
            <Logo />
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}
